/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigInfo
 */
export interface ConfigInfo {
    /**
     * 
     * @type {number}
     * @memberof ConfigInfo
     */
    maxFormContentSize: number;
}

/**
 * Check if a given object implements the ConfigInfo interface.
 */
export function instanceOfConfigInfo(value: object): value is ConfigInfo {
    if (!('maxFormContentSize' in value) || value['maxFormContentSize'] === undefined) return false;
    return true;
}

export function ConfigInfoFromJSON(json: any): ConfigInfo {
    return ConfigInfoFromJSONTyped(json, false);
}

export function ConfigInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'maxFormContentSize': json['maxFormContentSize'],
    };
}

export function ConfigInfoToJSON(value?: ConfigInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maxFormContentSize': value['maxFormContentSize'],
    };
}

